define('app/app',['require','glu/collection','glu/log'],function(require) {
	'use strict';

	// "APP" is a singleton that serves as a single root for all of our models.
	// It also serves as a debugging tool. The object is exposed as window.API so it's available to the debugging console.
	// For example, say you want to run a report manually from the console:
	//
	// API.domains.at(0).reportCollection().findWhere({name: 'My Report'}).run()

	var Collection = require('glu/collection'),
		log = require('glu/log');

	log.info('Type "API.reportLog" to see debugging info for report run requests. Type "API.sql" to see the SQL that was executed.');

	window.API = {
		openReports: new Collection(),
		domains: null, // Populated in controller.js to avoid circular dependency.
		user: null, // Populated in controller.js to avoid multiple server calls.
		users: null,
		segments: null, // Populated in controller.js to avoid multiple server calls.
		reportLog: [], // for debugging only
		sql: [] // for debugging only
	};

	return window.API;

});

